import { login, logout } from '@/api/user'
import Cookies from 'js-cookie'

const state = {
  hasLogin: Cookies.get('SessionStatus'),
  username: Cookies.get('username'),
  role: Cookies.get('role')
}

const mutations = {
  SET_HASLOGIN: (state, value) => {
    state.hasLogin = value
    if (value !== undefined) {
      Cookies.set('SessionStatus', value)
    } else {
      Cookies.remove('SessionStatus')
    }
  },
  SET_USERNAME: (state, value) => {
    state.username = value
    if (value !== '') {
      Cookies.set('username', value)
    } else {
      Cookies.remove('username')
    }
  },
  SET_ROLE: (state, value) => {
    state.role = value
    if (value !== '') {
      Cookies.set('role', value)
    } else {
      Cookies.remove('role')
    }
  }
}

const actions = {
  HasLogin ({ commit }, value) {
    commit('SET_HASLOGIN', value)
  },

  // 登录
  Login ({ commit }, { username, password }) {
    return new Promise((resolve, reject) => {
      login(username, password).then(res => {
        if (res.status === 200) {
          commit('SET_HASLOGIN', 'true')
          commit('SET_USERNAME', res.body.username)
          commit('SET_ROLE', res.body.role)
          resolve()
        } else {
          // eslint-disable-next-line prefer-promise-reject-errors
          reject('用户名或密码错误！')
        }
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 登出
  LogOut ({ commit }) {
    return new Promise((resolve, reject) => {
      logout().then(res => {
        commit('SET_HASLOGIN', undefined)
        commit('SET_USERNAME', '')
        commit('SET_ROLE', '')
        resolve()
      })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
